"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDataURL = exports.imageDataURLtoFile = exports.validateMailtoLink = exports.collaboratorLinkPathName = exports.isCollaboratorLink = exports.sanitizeLink = exports.isURL = void 0;
var es_toolkit_1 = require("es-toolkit");
var validator_1 = __importDefault(require("validator"));
var buffer_1 = require("buffer");
var isURL = function (str, allowProtocolRelative) {
    if (allowProtocolRelative === void 0) { allowProtocolRelative = false; }
    if (!(0, es_toolkit_1.isString)(str)) {
        return false;
    }
    if (allowProtocolRelative) {
        if (str.startsWith("mailto:")) {
            return validateMailtoLink(str);
        }
        if (str.startsWith("tel:") || str.startsWith("sms:")) {
            var phoneNumberFragment = str.slice(4);
            return validateTelephoneLink(phoneNumberFragment);
        }
        return validator_1.default.isURL(str, {
            allow_protocol_relative_urls: true,
        });
    }
    try {
        new URL(str);
    }
    catch (e) {
        return false;
    }
    return true;
};
exports.isURL = isURL;
var telephoneRegex = /\+?[0-9]+$/;
var validateTelephoneLink = function (phoneNumberFragment) {
    return telephoneRegex.test(phoneNumberFragment);
};
var validateMailtoLink = function (link) {
    var _a = __read(link.slice(7).split("?"), 3), email = _a[0], params = _a[1], error = _a[2];
    if (!error && validator_1.default.isEmail(email)) {
        var paramsCriteria = /^[a-zA-Z0-9& ._\-=@&,]+$/;
        return paramsCriteria.test(params);
    }
    return false;
};
exports.validateMailtoLink = validateMailtoLink;
var sanitizeLink = function (link) {
    try {
        var url = new URL(link, "https://fallback");
        if (url.hostname === "fallback") {
            return "";
        }
        if (url.hostname) {
            return url.hostname;
        }
        return url.protocol.substring(0, url.protocol.length - 1);
    }
    catch (err) {
        return "";
    }
};
exports.sanitizeLink = sanitizeLink;
var collaboratorLinkPathName = "collaborate";
exports.collaboratorLinkPathName = collaboratorLinkPathName;
var isCollaboratorLink = function (url) { return url && url.includes(collaboratorLinkPathName); };
exports.isCollaboratorLink = isCollaboratorLink;
var imageDataURLtoFile = function (dataUrl, filename) {
    var arr = dataUrl.split(",");
    if (arr.length < 2) {
        return undefined;
    }
    var mimeArr = arr[0].match(/:(.*?);/);
    if (!mimeArr || mimeArr.length < 2) {
        return undefined;
    }
    var mime = mimeArr[1];
    var buff = buffer_1.Buffer.from(arr[1], "base64");
    return new File([buff], filename, { type: mime });
};
exports.imageDataURLtoFile = imageDataURLtoFile;
var toDataURL = function (url) { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        return [2, fetch(url)
                .then(function (response) { return response.blob(); })
                .then(function (blob) {
                return new Promise(function (resolve, reject) {
                    var reader = new FileReader();
                    reader.onloadend = function () { return resolve(reader.result); };
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                });
            })];
    });
}); };
exports.toDataURL = toDataURL;
